import { withMetadata } from '@pf/shared-utility';
import { IdIsDefault } from '@control-tower/platform-core';

export const IdIsDefaultSymbol = 'IdIsDefault';
withMetadata<IdIsDefault>(IdIsDefaultSymbol, {
    id: String,
    isDefault: Boolean,
});
